<template>
  <div class="relative h-10 w-10">
    <ADeepCircleButton>
      <template #icon><GlobeBold /></template>
    </ADeepCircleButton>

    <select
      class="absolute inset-0 m-0 cursor-pointer appearance-none p-0 opacity-0"
      @change="setLanguage(($event.target as HTMLSelectElement).value)"
    >
      <option
        v-for="availableLanguage in restaurant.languages"
        :key="availableLanguage"
        :value="availableLanguage"
        :selected="availableLanguage === route.params.languageCode"
      >
        {{ getLanguageName(availableLanguage) }}
      </option>
    </select>
  </div>
</template>

<script lang="ts" setup>
import ADeepCircleButton from '@menu/Shared/ADeepCircleButton.vue';
import { getLanguageByCode } from '@/utils/language';
import GlobeBold from '@/phosphoricons/GlobeBold.vue';
import { useRoute, useRouter } from 'vue-router';
import getRestaurant from '@menu/Utils/getRestaurant';

const route = useRoute();
const router = useRouter();

const restaurant = getRestaurant();

const getLanguageName = (languageCode: string) => {
  return getLanguageByCode(languageCode).name;
};

const setLanguage = (languageCode: string) => {
  router.push({
    params: {
      languageCode: languageCode,
    },
    query: route.query,
  });
};
</script>
